/* eslint-disable @typescript-eslint/no-explicit-any */

type Options = {
  leading?: boolean;
};

const debounce = (fn: (...args: any[]) => any, delay = 0, options: Options = {}) => {
  let timeout: NodeJS.Timeout;
  const leading = options.leading ?? false;
  let called = false;

  const debounced = (...args: any[]) => {
    if (leading && !called) {
      fn(...args);
      called = true;

      return;
    }

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(...args);
      called = false;
    }, delay);
  };

  debounced.cancel = () => {
    clearTimeout(timeout);
    called = false;
  };

  return debounced;
};

export { debounce };

/* eslint-enable @typescript-eslint/no-explicit-any */
